import React, { useState } from 'react'
import NavBar from './navBar'
import Footer from './Footer'
import security6 from "../../assets/ethical6.svg"
import Hovered6 from "../../assets/hoveredEthical16.svg"
const AboutUs = () => {

  const count = [
    {
      numcount: "10k+",
      label: "Deal with recruiters"
    },
    {
      numcount: "1.5K+",
      label: "Team members "
    },
    {
      numcount: "1.7K+",
      label: "Hired candidates"
    },
    {
      numcount: "10K+",
      label: "Global candidates"
    }
  ]

  const cards = [
    {
      image: security6,
      hoveredImg: Hovered6,
      title: "Hiring team",
      desc: "We ensure that the hiring process is transparent, with clear communication to both candidates and businesses"
    },
    {
      image: security6,
      hoveredImg: Hovered6,
      title: "Job application & review",
      desc: "We ensure that AI and other technologies used on our platform only authorised personnel should have access to job applications, resumes, and other personal to maintain the transparency."
    }
  ]

  const info=[
    {
      label:"OUR MISSION",
      title:"Empowering Businesses with Global Talent",
      desc:"To connect businesses with skilled talent from around the world, enabling them to build diverse, high-performing teams. Leverage AI-powered solutions to simplify recruitment, making the hiring process faster, more accurate, and data-driven.Optimize and automate hiring workflows, reducing time-to-hire and ensuring better candidate matches for every role."
    },
    {
      label:"OUR MISSION",
      title:"Facilitating Efficient Hiring Processes",
      desc:"1800Hired is committed to transforming the recruitment process by providing businesses with an intuitive, efficient, and global platform to discover, evaluate, and hire the best talent in the world. 1800Hired is driven by a commitment to providing businesses with global, efficient, and diverse talent to build future-ready teams through smart recruitment technology."
    },
  ]

  const [isHovered, setIsHovered] = useState(false);
  const [isHoveredPart, setIsHoveredPart] = useState(false);
  const [isHoveredCard, setIsHoveredCard] = useState(false);
  return (
    <>
      <NavBar />
      <div className='latest-product-feature'>
        <div className='latest-product-container' style={{ height: "260px" }}>
          <p className='latest-produt-url'>About our company </p>
          <p className='latest-product-desc'>Exclusive job search with personalised support to boost your business performance </p>
        </div>
      </div>
      <div className='about-us-count-container'>
        {
          count.map((item, index) => {
            return (
              <div className='count-card'>
                <p className='count-card-count'>{item.numcount}</p>
                <p className='count-card-label'>{item.label}</p>
              </div>
            )
          })
        }
      </div>
      <div className='about-us-desc-container'>
        <div className='about-us-left-part'>
          <div className='about-image-card'></div>
        </div>
        <div className='about-us-right-part'>
          <div className='about-us-right-uppar-part'>
            {
              cards.map((card, index) => {
                return (
                  <div
                    key={index}
                    className="security-card"
                    style={{ width: "50%" }}
                    onMouseEnter={() => setIsHovered(index)}
                    onMouseLeave={() => setIsHovered(null)}
                  >
                    <div
                      className={`security-circle ${isHovered === index ? "hovered-circle" : ""
                        }`}
                    >
                      <img
                        src={isHovered === index ? card.hoveredImg : card.image}
                        alt={card.title}
                      />
                    </div>
                    <p
                      className={`security-card-head ${isHovered === index ? "hovered-title" : ""
                        }`}
                    >
                      {card.title}
                    </p>
                    <p
                      className={`security-card-desc ${isHovered === index ? "hovered-desc" : ""
                        }`}
                    >
                      {card.desc}
                    </p>
                  </div>
                )
              })
            }
          </div>
          <div className='about-us-right-lower-part'>
            <div
              className="about-diff-card"
               onMouseEnter={() => setIsHoveredCard(true)}
               onMouseLeave={() => setIsHoveredCard(false)}
            >
              <div style={{display:"flex",flexDirection:"column",gap:"10px",alignItems:"center",width:"50%"}}>
                <div
                      className={`security-circle ${isHoveredCard ? "hovered-circle" : ""
                        }`}
                    >
                      <img
                        src={isHoveredCard ? Hovered6 : security6}
                        alt="image"
                      />
                    </div>
              <p
                className={`security-card-head ${isHoveredCard ? "diff-hovered-label" : ""
                        }`}
              >
                Business scaling
              </p>
              </div>
              
              <p
                className={`security-card-desc  ${isHoveredCard ? "diff-hovered-label" : ""
                        }`}
                        style={{textAlign:"left"}}
              >
                We ensure that AI and other technologies used on our platform is to elevate the businesses and to their potential growth We encourage businesses to create diverse and inclusive teams. 
              </p>
            </div>
          </div>
        </div>
      </div>
      <div className='about-us-desc-container'>
        <div className='about-us-left-part-second'>
             {
              info.map((card, index) => {
                return (
                  <div
                    key={index}
                    className="diff-card"
                    style={{ width: "100%" }}
                    onMouseEnter={() => setIsHoveredPart(index)}
                    onMouseLeave={() => setIsHoveredPart(null)}
                  >
                    <p
                      className={`diff-card-label ${isHoveredPart === index ? "diff-hovered-label" : ""
                        }`}
                    >
                      {card.label}
                    </p>
                     <p
                      className={`diff-card-head ${isHoveredPart === index ? "diff-hovered-desc" : ""
                        }`}
                    >
                      {card.title}
                    </p>
                    <p
                      className={`diff-card-desc ${isHoveredPart === index ? "diff-hovered-desc" : ""
                        }`}
                    >
                      {card.desc}
                    </p>
                  </div>
                )
              })
            }
        </div>
        <div className='about-us-right-part-second'>
            <div className='about-image-card'></div>
        </div>
      </div>
      <Footer />
    </>
  )
}

export default AboutUs